import React from "react";
import { useGlobal, withGlobal } from "utils/globalState";
import { useLocation } from "react-router-dom";

import { PageHeader } from "@sainsburys-tech/luna-site-layout";
import {
  Sainsburys,
  Nectar,
  Argos,
  SainsburysSmartShop,
  NectarWordmarkWhite,
} from "@sainsburys-tech/luna-images";
import { isMultiMissionUrl, isLoginUrl, missionId  } from "utils/urls";
import isMobile from "utils/isMobile";
import DocumentHead from "./DocumentHead";
import { SavingCard } from "images/SavingCard";
import { missionNames } from "constants/missions";

const logoMap = {
  nectar: isMobile() ? (
    <NectarWordmarkWhite label="Nectar" width="110px" />
  ) : (
    <Nectar label="Nectar" width="110px" />
  ),
  smartshop: (
    <SainsburysSmartShop label="Sainsbury's SmartShop" width="140px" />
  ),
  argos: <Argos label="Argos" width="82px" />,
  savingcard: (
      <SavingCard
        aria-label="Sainsbury's Savings Card"
        width={isMobile() ? "180px" : "220px"}
        style={{ display: "block" }}
      />
    ),
  default: (
    <Sainsburys
      label="Sainsburys Group plc"
      width={isMobile() ? "96px" : "140px"}
    />
  ),
};

// Background colour for the header bar — use explicit hex values rather than
// Luna utility classes so the correct brand colour is guaranteed regardless of
// which $ln-theme was compiled into the CSS bundle.
const headerStyleMap = {
  nectar: { backgroundColor: "#8223fa" },
  default: { backgroundColor: "#ffffff" },
};

const makeLogo = (BrandLogo) => {
  if (missionId === missionNames.SAVINGCARD) {
    return logoMap["savingcard"];
  }
  return logoMap[BrandLogo] || logoMap["default"];
};

const getHeaderStyle = (logo) => {
  return headerStyleMap[logo] || headerStyleMap["default"];
};

// In bosun_up the pathname includes the PUBLIC_URL prefix (e.g. /login-ui/nectar/login)
// but isLoginUrl / isMultiMissionUrl compare against React Router paths (e.g. /nectar/login).
// Find where the missionId segment starts and take the path from there —
// this works both locally (no prefix) and in production (with /login-ui prefix).
const getRelativePath = (url) => {
  const idx = missionId ? url.indexOf(`/${missionId}`) : -1;
  return idx > -1 ? url.slice(idx) : url;
};

// Hide the top header bar on the login page for all missions:
// - Nectar: has its own logo inside MultiMissionHeader so top header would duplicate it
// - GOL / myaccount / smartshop: the Phantom embedding never showed a top logo bar
//   on the login page; showing the Sainsburys logo here is a Bosun migration regression
const shouldShowHeader = (url) => {
  const relativePath = getRelativePath(url);
  if (isMultiMissionUrl(relativePath)) return false;
  if (isLoginUrl(relativePath)) return false;
  return true;
};

const Header = ({ missionHomepage }) => {
  const [logo] = useGlobal("logo");
  const [readable_mission_name] = useGlobal("readable_mission_name");
  const location = useLocation();

  return (
    <>
      <DocumentHead logo={logo} mission={readable_mission_name} />
      {shouldShowHeader(location.pathname) && readable_mission_name && (
        <PageHeader>
          <div
            style={{ padding: "20px", lineHeight: 0, ...getHeaderStyle(logo) }}
          >
            <div data-testid="mission-logo">{makeLogo(logo)}</div>
          </div>
        </PageHeader>
      )}
    </>
  );
};

export default withGlobal((global) => ({
  missionHomepage: global.mission_homepage,
}))(Header);
